import { createApp } from 'vue';
// import Vuelidate from '@vuelidate/core';
// import VueScrollTo from 'vue-scrollto';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import VueGtag from 'vue-gtag-next';
// import VCalendar from 'v-calendar';
import VueGoodTablePlugin from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import App from './App.vue';
import axios from './plugins/axios';
// import './registerServiceWorker';
import router from './router';
import store from './store';

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store);
app.use(router);
app.use(VueGoodTablePlugin);
// app.use(Vuelidate);
// app.use(VueScrollTo);
// app.use(VueGtag, {
//   property: {
//     id: '',
//     router,
//   },
// });
// app.use(VCalendar, {});
// カスタムディレクティブ「v-sound」を定義
app.directive('sound', {
  mounted(el) {
    const soundPath = '/sound/select.mp3';
    const sound = new Audio(soundPath);

    el.addEventListener('click', (event) => {
      const buttonElement = event.target.closest('button');

      if (buttonElement && el.contains(buttonElement)) {
        sound.currentTime = 0; // 再生位置をリセット
        sound.play().catch((error) => {
          console.error('Audio play failed:', error);
        });
      }
    });
  },
});
app.mount('#app');
